import styled from 'styled-components'

const ShareLinkStyle = styled.div`
	--shareIconWrapSize: var(--sp9x);
	--shareIconDistance: var(--sp3x);

	display: flex;
	flex-direction: column;
	width: fit-content;
	position: sticky;
	top: 10%;

	i {
		font-size: var(--p1);
		line-height: 1;
		display: block;

		&:before {
			color: var(--primaryColor9);
		}
	}

	.share-item {
		display: flex;
		align-items: center;
		justify-content: center;
		width: var(--shareIconWrapSize);
		height: var(--shareIconWrapSize);
		border: 1px solid var(--primaryColor9);
		border-radius: 50%;
		margin-top: var(--shareIconDistance);
	}

	.copy-text {
		position: absolute;
		top: 100%;
		right: 0;
		margin-top: var(--shareIconDistance);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--shareIconWrapSize: var(--sp8x);
		--shareIconDistance: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--shareIconWrapSize: var(--sp7x);
		--shareIconDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--shareIconWrapSize: var(--sp7x);
		--shareIconDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--shareIconWrapSize: var(--sp7x);
		--shareIconDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--shareIconWrapSize: var(--sp6x);
		--shareIconDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--shareIconWrapSize: var(--sp6x);
		--shareIconDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--shareIconWrapSize: var(--sp6x);
		--shareIconDistance: var(--sp2x);
	}
`

export default ShareLinkStyle
